import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { Col, Container, Row } from 'reactstrap';

const Footer = (props) => {
    return (
        <React.Fragment>
            <footer className="footer">
                <Container fluid>
                    <Row>
                        <Col sm={6}>
                            {new Date().getFullYear()} © Le Conseiller du BTP.
                        </Col>
                    </Row>
                </Container>
            </footer>
        </React.Fragment>
    );
};

Footer.propTypes = {
    location: PropTypes.object,
    t: PropTypes.any,
};
export default withRouter(withTranslation()(Footer));